import type { TParametrosRotinaArquivo } from '@/domain/simulador/factories/concrete/horizontal/sacocv/rotina-arquivo-base'
import type { FatorTipo, TMargem } from '@/features/simulador/brasil/types'

type TAutonomia = keyof Pick<
  TParametrosRotinaArquivo,
  'percentualAutonomiaVendedorSobrePoupanca1Por3' | 'percentualAutonomiaVendedorSobrePoupanca2Por3'
>

export class CalculadoraDeFatorDeVendedor {
  static calcular(margens: TMargem[], percentualPoupanca: number, params: Omit<TParametrosRotinaArquivo, 'dataSaldo'>) {
    const tipos: FatorTipo[] = ['margemVendedor1Por3', 'margemVendedor2Por3', 'margemVendedor3Por3']
    const autonomias: TAutonomia[] = [
      'percentualAutonomiaVendedorSobrePoupanca1Por3',
      'percentualAutonomiaVendedorSobrePoupanca2Por3',
    ]
    const percentualPoupancaEmDecimal = percentualPoupanca / 100
    const margemMap = new Map(margens.map((m) => [m.tipo, m.fator ?? 0]))
    const fatores = tipos.map((tipo) => margemMap.get(tipo) ?? 0)
    const fatorPadrao = fatores.at(-1) ?? 0

    for (const [index, autonomia] of autonomias.entries()) {
      const percentualAutonomiaEmDecimal = Number(params[autonomia] ?? 0) / 100

      if (percentualPoupancaEmDecimal > percentualAutonomiaEmDecimal) {
        return fatores[index] ?? fatorPadrao
      }
    }

    return fatorPadrao
  }
}
